import Logger from './logger';
import { getCode, isRelogin } from './open.helpers';
import { getInitObject } from './init';
import { isLoggedInECare, verifyCode } from './auth';
import { getGenesysConfig } from './genesys';
import update from './update';
import { DEVICES } from './device';

const openNewChat = (args, callbacks) => {
    Logger.log('tenant -> ' + window.WC.Closer._closerOrgId);
    Logger.log('args -> ' + JSON.stringify(args));
    const initParams = JSON.stringify(args);
    args.initParams = initParams;

    if (callbacks && callbacks.onClose) {
        window.WC.Closer._onCloseCallback = callbacks.onClose;
    }

    const genesysConfig = getGenesysConfig(args);
    if (genesysConfig) {
        window.WC._sessionStorage.set('genesysConfig', genesysConfig);
        callbacks = callbacks || {};
        callbacks.onMinimize = () => {
            window.WC.Closer.hide();
            window.OPLWCParent.open({ config: genesysConfig });
        };
        if (genesysConfig.fromGV) {
            window.OPLWCParent?.close(true);
        }
        if (
            window.WC._localStorage.get('CloserState') === 'hidden' &&
            window.WC.Closer._isInitialized
        ) {
            window.WC.Closer.maximize();
            return;
        }
    }

    getCode({
        userStatus: isLoggedInECare(),
        code: args.code,
        device: window.WC.Closer.device,
        callback: (code) => {
            try {
                Logger.log(`code=${code}`);

                if (!verifyCode(code)) {
                    window.WC.Closer.close('onNativeClose-code-error', args, callbacks.onClose);
                }

                const initObject = getInitObject(args, callbacks, code);
                const wcVersion = window.WC?.version() ?? '-';
                if (
                    code &&
                    isRelogin(window.WC._localStorage.get('reloginRequestTimestamp', 'wc.relogin'))
                ) {
                    Logger.log('reinit');
                    Logger.logToCloserApi(
                        `reinit: v=${wcVersion}, initO=${JSON.stringify(
                            initObject
                        )}, args=${JSON.stringify(args)}`
                    );
                    window.closer.reinit(initObject);
                } else {
                    Logger.log('init');
                    Logger.logToCloserApi(
                        `init: v=${wcVersion}, initO=${JSON.stringify(
                            initObject
                        )}, args=${JSON.stringify(args)}`
                    );
                    window.closer.init(initObject);
                }
                window.WC._localStorage.set('CloserState', 'initialized');
            } catch (error) {
                Logger.logToGWE('CloserCodeError', { error: error });
                Logger.error(error);
            }
        }
    });
};

const openStartedChat = (args) => {
    Logger.log('open started chat');
    Logger.log('args -> ' + JSON.stringify(args));
    if (JSON.stringify(args) !== '{}') {
        update(args);
    }
    window.closer.openWidget();
};

const isChatStarted = (isPageReload) => {
    if (isPageReload) {
        return false;
    } else if (window.WC.Closer.isOpen()) {
        return true;
    }
    return false;
};

const open = (args = {}, callbacks) => {
    if (window.WC.Closer.device === DEVICES.DESKTOP && isChatStarted(args?.pageReload)) {
        openStartedChat(args);
    } else {
        if (args.showAfter) {
            setTimeout(() => {
                openNewChat(args, callbacks);
            }, parseInt(args.showAfter) * 1000);
        } else {
            openNewChat(args, callbacks);
        }
    }
};

const isOpen = () =>
    ['opened', 'closed', 'initialized', 'hidden'].includes(
        window.WC._localStorage.get('CloserState')
    );

const isOpened = () => window.WC.Closer.isOpen();

export { open, isOpen, isOpened };
